module.exports = __webpack_public_path__ + "img/loader.d65dcb26.png";